import React, { useState } from "react";
import GigsSupportList from "../../components/GigsSupport/GigsSupportList";
import GigsSupportModal from "../../components/GigsSupport/GigsSupportModal";
import FilterButton from "../../components/Common/FilterButton";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as GigsSupportActions from "../../store/actions/GigsSupport";
import { Heading } from "../../constants/assets/containers";

const GigsSupport = ({
  gigsSupportList,
  activeFilters,
  slotHistoryDetail,
  setSlotHistoryDetail,
}) => {
  const [modalState, setModalState] = useState("");
  const handleClick = (type) => {
    setModalState(type);
  };

  const handleClose = () => {
    setModalState("");
  };

  return (
    <div className="Gigs-Support-View">
      <div>
        <div
          className="actionBar mb-20 flex"
          style={{ justifyContent: "space-between" }}
        >
          <Heading>Gigs Support</Heading>
          <FilterButton
            activeFilters={activeFilters}
            handleClick={() => handleClick("Filter")}
          />
        </div>
      </div>
      <GigsSupportList
        gigsSupportList={gigsSupportList}
        slotHistoryDetail={slotHistoryDetail}
        setSlotHistoryDetail={setSlotHistoryDetail}
      />
      {modalState && (
        <GigsSupportModal
          modalState={modalState}
          handleClose={handleClose}
          slotHistoryDetail={slotHistoryDetail}
          setSlotHistoryDetail={setSlotHistoryDetail}
        />
      )}
    </div>
  );
};

function mapStateToProps(state) {
  const { GigsSupport } = state;
  return {
    gigsSupportList: GigsSupport.gigsSupportList,
    activeFilters: GigsSupport.activeFilters,
    slotHistoryDetail: GigsSupport.slotHistoryDetail,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getGigsSupportList: bindActionCreators(
      GigsSupportActions.getGigsSupportList,
      dispatch
    ),
    setSlotHistoryDetail: bindActionCreators(
      GigsSupportActions.setSlotHistoryDetail,
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(GigsSupport);
